module.exports = __webpack_public_path__ + "img/10.429e36dc.png";